module.exports = __webpack_public_path__ + "img/done-outline.d343bfa8.svg";